import { render, staticRenderFns } from "./profile-admin.vue?vue&type=template&id=50f5c5f2&"
import script from "./profile-admin.vue?vue&type=script&lang=js&"
export * from "./profile-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports